import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SearchService from "services/searchService";

export const initialState = {
  searchedPatients: [],
  searching: false,
  errorMessages: [],
};

export const searchPatient = createAsyncThunk(
  "/searchPatient",
  async (searchParams, { rejectWithValue }) => {
    try {
      const response = await SearchService.searchPatient(searchParams);
      const code = response.code;
      return {
        code: code,
        orders: response.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a order",
        }
      );
    }
  }
);

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.fetching = !state.fetching;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchPatient.pending, (state) => {
        state.searching = true;
      })
      .addCase(searchPatient.fulfilled, (state, action) => {
        state.searching = false;
        state.searchedPatients = action.payload.orders;
      })
      .addCase(searchPatient.rejected, (state, action) => {
        state.searching = false;
      });
  },
});

export const { showLoading } = searchSlice.actions;

export default searchSlice.reducer;
